"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = create;
exports.findAll = findAll;
exports.notice = notice;
exports.remove = remove;
exports.update = update;
var _request = _interopRequireDefault(require("@/utils/request"));
function findAll(listQuery) {
  return (0, _request.default)({
    url: "/notification",
    params: listQuery
  });
}
function create(data) {
  return (0, _request.default)({
    url: "/notification",
    method: "post",
    data: data
  });
}
function update(id, data) {
  return (0, _request.default)({
    url: "/notification/".concat(id, "/update"),
    method: "post",
    data: data
  });
}
function remove(id) {
  return (0, _request.default)({
    url: "/notification/".concat(id, "/delete"),
    method: "post"
  });
}
function notice(id) {
  return (0, _request.default)({
    url: "/notification/".concat(id, "/notice"),
    method: "post"
  });
}